import React from 'react';

const ShippingPolicy = () => {
  const styles = {
    container: {
      minHeight: '100vh',
      width: '100%',
      // Premium dark overlay with the jewelry background
      backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url("https://images.unsplash.com/photo-1643237202321-8f8de00975ad?q=80&w=2070&auto=format&fit=crop")`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
      display: 'flex',
      justifyContent: 'center',
      padding: '80px 20px',
      fontFamily: "'Playfair Display', serif",
    },
    glassCard: {
      background: '#fff', 
      maxWidth: '850px',
      width: '100%',
      padding: '50px',
      borderRadius: '4px', // Sophisticated sharp edges
      boxShadow: '0 40px 100px rgba(0,0,0,0.6)',
      color: '#111',
      position: 'relative',
      overflow: 'hidden',
    },
    goldBar: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '5px',
      background: 'linear-gradient(90deg, #B8860B, #D4AF37, #B8860B)',
    },
    header: {
      textAlign: 'center',
      marginBottom: '50px',
    },
    title: { 
      fontSize: '2.8rem', 
      fontWeight: '400', 
      textTransform: 'uppercase', 
      letterSpacing: '8px',
      margin: '0',
      color: '#1a1a1a'
    },
    section: { marginBottom: '45px' },
    heading: { 
      color: '#B8860B', 
      fontSize: '1.1rem', 
      fontWeight: 'bold',
      textTransform: 'uppercase',
      letterSpacing: '2px',
      borderBottom: '1px solid #eee',
      paddingBottom: '10px',
      marginBottom: '20px'
    },
    qaBox: {
      background: '#fcfaf2',
      border: '1px solid #e2d1a6',
      padding: '30px',
      margin: '40px 0',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      marginTop: '20px',
    },
    th: { textAlign: 'left', padding: '15px', borderBottom: '2px solid #111', fontSize: '0.85rem', textTransform: 'uppercase' },
    td: { padding: '15px', borderBottom: '1px solid #eee', color: '#444' },
    footer: {
      marginTop: '60px',
      textAlign: 'center',
      fontSize: '0.9rem',
      color: '#777',
      borderTop: '1px solid #eee',
      paddingTop: '30px'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.glassCard}>
        <div style={styles.goldBar}></div>
        
        <div style={styles.header}>
          <h1 style={styles.title}>Shipping & Logistics</h1>
          <p style={{letterSpacing: '4px', fontSize: '0.75rem', color: '#999', textTransform: 'uppercase', marginTop: '15px'}}>
            Premium Delivery Experience
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.heading}>01. Dispatch Philosophy</h2>
          <p>
            At <b>RoopShingar</b>, we understand that elegance cannot wait. Every order undergoes a rigorous 
            quality check and is dispatched from our fulfillment suite within <b>12 to 24 hours</b> of confirmation.
          </p>
        </div>

        {/* TRUST FEATURE - VIDEO RECORDING */}
        <div style={styles.qaBox}>
          <h3 style={{margin: '0 0 15px 0', fontSize: '1.2rem', letterSpacing: '1px'}}>AUTHENTICITY & QUALITY SHIELD</h3>
          <p style={{margin: 0, fontSize: '1rem', fontStyle: 'italic', color: '#555'}}>
            To safeguard your purchase, our team records a <b>comprehensive video of the inspection and packaging</b> 
            for every order. This ensures that the exquisite piece you selected reaches you in pristine condition.
          </p>
          <div style={{marginTop: '20px', padding: '10px', borderLeft: '3px solid #111', fontSize: '0.9rem', fontWeight: 'bold'}}>
            * NOTE: An uninterrupted unboxing video is required from the customer to process any rare transit-related claims.
          </div>
        </div>

        <div style={styles.section}>
          <h2 style={styles.heading}>02. Delivery Timelines</h2>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Zone</th>
                <th style={styles.th}>Estimated Transit Time</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={styles.td}>Intra-State (Regional)</td>
                <td style={styles.td}>3 — 5 Business Days</td>
              </tr>
              <tr>
                <td style={styles.td}>Inter-State (National)</td>
                <td style={styles.td}>5 — 8 Business Days</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style={styles.section}>
          <h2 style={styles.heading}>03. Concierge & Tracking</h2>
          <p>
            We exclusively utilize premium air-cargo partners like <b>BlueDart, Delhivery, and Shiprocket</b>. 
            Detailed tracking credentials will be shared instantly via your registered mobile number and email.
          </p>
        </div>

        <div style={styles.footer}>
          <p><b>Customer Relations:</b> +91 [YOUR_PHONE_NUMBER]</p>
          <p><b>Email:</b> care@roopshingar.com</p>
          <p style={{marginTop: '20px', fontSize: '0.7rem', color: '#ccc'}}>
            REGISTERED OFFICE: [INSERT YOUR ACTUAL OFFICE ADDRESS HERE]
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;